module.exports = __webpack_public_path__ + "static/media/r4.026eb40d.png";